import { motion } from 'framer-motion';
import { Server, Zap, Globe, MessageCircle, Cloud, Shield, Rocket, Code } from 'lucide-react';

const icons = [Server, Zap, Globe, MessageCircle, Cloud, Shield, Rocket, Code];

export function FloatingElements() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden opacity-20 dark:opacity-10">
      {Array.from({ length: 12 }).map((_, i) => {
        const Icon = icons[i % icons.length];
        const size = Math.random() * 40 + 30;
        const delay = Math.random() * 5;
        const duration = Math.random() * 10 + 15;
        const x = Math.random() * 100;
        const y = Math.random() * 100;

        return (
          <motion.div
            key={i}
            className="absolute"
            style={{
              left: `${x}%`,
              top: `${y}%`,
              width: size,
              height: size,
            }}
            animate={{
              y: [0, -30, 0],
              x: [0, Math.random() * 20 - 10, 0],
              rotate: [0, 360],
              scale: [1, 1.1, 1],
            }}
            transition={{
              duration,
              delay,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          >
            <div className="w-full h-full rounded-2xl bg-gradient-to-br from-emerald-500/30 to-teal-600/30 backdrop-blur-sm flex items-center justify-center">
              <Icon className="w-1/2 h-1/2 text-emerald-600 dark:text-emerald-400" />
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
